export default {
  headerContent: {
    title: 'Bereket Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Konut Sigortası',
    description: {
      title: 'Bereket Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Bereket Sigorta’dan alacağınız konut sigortası ile konutunuzu ve eşyalarınızı koruma altına alabilirsiniz.',
        'Konut sigortası; dahili su, fırtına ve hırsızlık gibi risklere karşı koruma sağlamaktadır. Bununla beraber büyük finansal kayıplara karşı güvence sunar.'
      ]
    },
    subContent: {
      title: 'Bereket Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Yangın Mali Mesuliyet',
            'Dahili Su',
            'Kar Ağırlığı',
            'Duman',
            'Kara Taşıtları Çarpması',
            'Hava Taşıtları Çarpması',
            'Deniz Taşıtları Çarpması',
            'Sel-Su Baskını',
            'Fırtına',
            'Enkaz Kaldırma',
            'GLKHHKNH ve Terör',
            'Deprem',
            'Hırsızlık',
            'Cam Kırılması Teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Bereket Sigorta Konut Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Hukuksal Koruma Teminatı',
            'Ferdi Kaza Teminatı',
            'Elektronik Cihaz Teminatı',
            'Üçüncü Şahıs Mali Sorumluluk Teminatı',
            'Makine Kırılması Teminatını içerir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Asistans Hizmetleri Nelerdir?',
      content: [
        {
          paragraph:
            'Bereket Sigorta konut sigortası müşterilerine özel olarak aşağıdaki hizmetleri ücretsiz olarak sunmaktadır.',
          subList: [
            'Konut Bilgi Hattı',
            'Su Tesisatı Hizmeti',
            'Elektrik Tesisatı Hizmeti',
            'Çilingir Hizmeti',
            'Cam İşleri Hizmeti',
            'Otelde Konaklama',
            'Sigortalı Faturalarının Ödenmesi',
            'İkametgâha Öngörülmeyen Dönüş',
            'Tıbbi Bilgi ve Danışma',
            'Tıbbi Nakil (Kara Ambulansı)',
            'Konuta Doktor Gönderimi',
            'Hastanede Kalma Durumunda Yardım',
            'Konuta Uzman Tıbbi Ekip',
            'Ekipman Yollanması',
            'İş yeri Bilgi Hattı',
            'Su Tesisatı Hizmeti',
            'Elektrik Tesisatı Hizmeti',
            'Çilingir Hizmeti',
            'Cam İşleri Hizmeti',
            'Turistik, Kültürel ve Sosyal Aktivitelerle İlgili Rezervasyon',
            'Bilet Alımı/Ulaştırma',
            'Otel rezervasyonları',
            'Restaurant Rezervasyonu',
            'Kiralık Araç Rezervasyonları',
            'Uçak Bileti Alma / Ulaştırma',
            'Seyahat Organizasyon Hizmetleri',
            'Hediye, Çiçek vb. Gönderimler',
            'İş yeri İhtiyaçlarına Yönelik Organizasyonlar',
            'Kurye ve Kargo Hizmetleri',
            'Vize ve Konsolosluk Bilgilendirme Hattı',
            'Araç Bilgi Hattı',
            'Organizasyon Hizmetleri',
            'Konut Onarım Paketi',
            'Kombi veya Klima Bakım Paketi',
            'Koltuk ve Halı Yıkama Paketi',
            'Petek Temizliği Hizmetini içermektedir.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Eşya Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Eşya sigortası kapsamı konut içerisinde bulunan eşyaların başına gelebilecek hasarları güvence altına almaktadır. Eşya sigortası sadece eşyalara güvence sağlamaktadır. Dairede oluşabilecek hasarları güvence altına almamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Konut Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortası teminat dışı kalan haller poliçeye ekletilmeyen teminatlar ve konut sigortası genel şartlarında belirlenmiş olan hallerdir.',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası genel şartlarına göre teminat dışı kalan haller;',
          subList: [
            'Konut sigortası genel şartlarına göre teminat dışı bırakılmış haller aşağıdadır.',
            'Savaş, her türlü savaş olayları, istila, yabancı düşman hareketleri, çarpışma (savaş ilan edilmiş olsun veya olmasın), iç savaş, ihtilal, isyan, ayaklanma ve bunların gerektirdiği inzibati ve askeri hareketler nedeniyle meydana gelen bütün zararlar,',
            'Herhangi bir nükleer yakıttan veya nükleer yakıtın yanması sonucu nükleer artıklardan ya da bunlara atfedilen sebeplerden meydana gelen iyonlayıcı radyasyonların veya radyo-aktivite bulaşmalarının ve bunların gerektirdiği askeri, inzibati tedbirlerin sebep olduğu bütün zararlar (Bu bentte geçen yanma deyimi kendi kendini idame ettiren herhangi bir nükleer ayrışım olayını da kapsayacaktır.),',
            'Kamu otoritesi tarafından sigortalı varlıklar üzerinde yapılacak tasarruflar sebebiyle meydana gelen bütün zararlar,',
            'Yangın olmaksızın, sigortalı varlıkların kendi kusurlarından veya kendi bünyelerinde meydana gelen bozulmalar nedeniyle uğradıkları zararlar,',
            'Yangın olmaksızın sigortalı varlıkların işlenmek üzere veya başka bir nedenle ateşe, sıcaklığa tutulmasından, ateş bulunan benzeri bir yere düşmesinden, atılmasından, elbise, çamaşır ve diğer eşya yanıklığı gibi alev almaksızın kavrulmasından, yanmasından kaynaklanan veya ısıtma, aydınlatma, ütüleme aletleri ile lamba, mum, sigara ve bunların benzerlerine temasından doğan zararlar,',
            'Yangın olmaksızın, elektrikle çalışan her türlü motor, elektrikli veya elektronik alet, cihaz, tesisat ve kordonlarının kısa devre, topraklama, voltaj iniş çıkışları ile bu yüzden ısınma ve endüksiyon cereyanı gibi nedenlerle uğrayacakları zararlar,',
            'Alçak basınç sebebiyle kapların içeri doğru çökmesi, yırtılması, benzeri şekilde deformasyonu, yıpranması, santrifüj kuvvetler ve mekanik olaylar nedeniyle sigortalı cihaz ya da motorlarda meydana gelen bütün zararlar.'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası İçin Gerekli Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Kimlik bilgileri,',
            'Konutun açık adresi,',
            'Bulunduğu kat,',
            'Brüt metrekare,',
            'İnşa bedeli,',
            'Eşya bedeli gibi belge ve bilgilerdir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Konut Sigortası Yaptırırken Nelere Dikkat Etmeliyiz?',
      content: [
        {
          paragraph:
            'Konut sigortası alırken dikkat etmeniz gereken birkaç husus vardır.',
          subList: null
        },
        {
          paragraph: 'Bu hususlar;',
          subList: [
            'Teklifte yazan teminatlar ve limitler.',
            'Poliçe üzerinde yazan konut metrekare bilgisi.',
            'Konut sigortası yanında hediye olarak sunulan hizmetler.',
            'Konut sigortası konuta ve kişiye özel olarak düzenlenmektedir. Bu yüzden teklif üzerinde yazan adres bilgileri ve sigortalı bilgilerini de kontrol edilmelidir.'
          ]
        }
      ]
    },
    {
      title: 'Bina Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Konut sigortası kapsamında yer alan bina bedeli hasar oluşması sonucunda evinizin kullanılamaz hale gelmesi veya yıkılması sonucunda tekrar eski haline getirebilmek için gerekli olan finansal ücrete denir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Hasarsızlık İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Konut sigortasında bulunan hasarsızlık indirimi poliçe vadesi boyunca hiç hasar olmaması durumunda kazanılan ekstra indirimdir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Geçerlilik Süresi Ne Kadar?',
      content: [
        {
          paragraph: 'Konut sigortası geçerlilik süresi 1 yıldır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Elektronik Eşyayı Karşılar M?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları arasında elektronik cihaz teminatı bulunması durumunda karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Konut Sigortası Yaptırmalıyım?',
      content: [
        {
          paragraph:
            'Konut sigortası konutunuz ve eşyalarını risklere karşı korumaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası olmaması risklerin oluşması sonucunda büyük çaplı maddi kayıpların var olmasına neden olmaktadır. Bu büyük çaplı maddi kayıpları düşük primler ile güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Deprem Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Deprem hasarları konut sigortası kapsamında yalnızca poliçe kapsamında deprem teminatı ve deprem sigortası olması durumunda karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Yaptırmak Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Konut sigortası isteğe bağlı bir sigorta ürünüdür. Yaptırılması zorunlu değildir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Konut Sigortası Mobilya Mini Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Konut sigortanız kapsamında mini hasarlarınız karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Rutubet Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Rutubet hasarları poliçe kapsamına alınması koşuluyla karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Konut Sigortası Kiracı Tarafından Yaptırılabilir Mi?',
      content: [
        {
          paragraph:
            'Konut sigortası kiracı tarafından konut içerisinde bulunan eşyaları için yaptırılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası ödemelerini kredi kartınızla yapabilirsiniz. Kredi kartınızla vadeli bir şekilde poliçe tanzim işleminizi gerçekleştirebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Sorgulaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası sorgulaması gerekli bilgiler girilerek yapılmaktadır.',
          subList: null
        },
        {
          paragraph:
            'Alokasko ekibi bilgilerin girilmesi ardından sizin için en uygun konut sigortası sorgulaması yaparak size sunmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası hesaplaması, konut ve sigortalı bilgileri girilerek yapılmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Konut Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası fiyatları sigortalanacak konutun bedeli, eşya bedelleri ve sigortalının istemiş olduğu teminatlar doğrultusunda değişmektedir. En doğru fiyatları karşılaştırmak için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Bereket Sigorta Konut Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Online konut sigortası fiyatlarını değerlendirmek için teklif al formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
